import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const apiUrl = (path) => `${api.defaults.baseURL}${path}`;
export const fileUrl = (path) => apiUrl(`/files/${path}`);


api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("access_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !String(orig.url).includes("/auth/")) {
      orig._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("access_token", data.access_token);
        return api(orig);
      } catch {
        localStorage.removeItem("access_token");
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
